// -----------------------------------------------------------------------------
// Core
// -----------------------------------------------------------------------------

import alternativeValues from '../alt2';

// -----------------------------------------------------------------------------
// Keys
// -----------------------------------------------------------------------------

const keys = {
	// row 0
	'`': ['ё', ''],
	'~': ['Ё', '₴'],
	'#': ['№'],
	$: [';'],
	'@': ['"'],
	'^': [':'],
	Ё: ['~', '₴'],
	'₴': ['~', 'Ё'],

	// row 1
	q: ['й'],
	w: ['ц'],
	e: ['у'],
	r: ['к'],
	t: ['е'],
	y: ['н'],
	u: ['г'],
	i: ['ш'],
	o: ['щ'],
	p: ['з'],
	'[': ['х'],
	']': ['ъ', 'ї'],
	Q: ['Й'],
	W: ['Ц'],
	E: ['У'],
	R: ['К'],
	T: ['Е'],
	Y: ['Н'],
	U: ['Г'],
	I: ['Ш'],
	O: ['Щ'],
	P: ['З'],
	'{': ['Х'],
	'}': ['Ъ', 'Ї'],
	ц: ['w', 'ц'],
	у: ['e', 'у'],
	к: ['r', 'к'],
	е: ['t', 'е'],
	н: ['y', 'н'],
	г: ['u', 'г'],
	ш: ['i', 'ш'],
	щ: ['o', 'щ'],
	з: ['p', 'з'],
	х: ['[', 'х'],
	ъ: [']', 'ї'],
	ї: [']', 'ъ'],
	Ц: ['W', 'Ц'],
	У: ['E', 'У'],
	К: ['R', 'К'],
	Е: ['T', 'Е'],
	Н: ['Y', 'Н'],
	Г: ['U', 'Г'],
	Ш: ['I', 'Ш'],
	Щ: ['O', 'Щ'],
	З: ['P', 'З'],
	Х: ['{', 'Х'],
	Ъ: ['}', 'Ї'],
	Ї: ['}', 'Ъ'],

	// row 2
	a: ['ф'],
	s: ['ы', 'і'],
	d: ['в'],
	f: ['а'],
	g: ['п'],
	h: ['р'],
	j: ['о'],
	k: ['л'],
	l: ['д'],
	';': ['ж'],
	"'": ['э', 'є'],
	A: ['Ф'],
	S: ['Ы', 'І'],
	D: ['В'],
	F: ['А'],
	G: ['П'],
	H: ['Р'],
	J: ['О'],
	K: ['Л'],
	L: ['Д'],
	':': ['Ж'],
	'"': ['Э', 'Є'],
	ф: ['a', 'ф'],
	ы: ['s', 'і'],
	і: ['s', 'ы'],
	в: ['d', 'в'],
	а: ['f', 'а'],
	п: ['g', 'п'],
	р: ['h', 'р'],
	о: ['j', 'о'],
	л: ['k', 'л'],
	д: ['l', 'д'],
	ж: [';', 'ж'],
	э: ["'", 'є'],
	є: ["'", 'э'],
	Ф: ['A', 'Ф'],
	Ы: ['S', 'І'],
	І: ['S', 'Ы'],
	В: ['D', 'В'],
	А: ['F', 'А'],
	П: ['G', 'П'],
	Р: ['H', 'Р'],
	О: ['J', 'О'],
	Л: ['K', 'Л'],
	Д: ['L', 'Д'],
	Ж: [':', 'Ж'],
	Э: ['"', 'Є'],
	Є: ['"', 'Э'],
	'|': ['/'],

	// row 3
	z: ['я'],
	x: ['ч'],
	c: ['с'],
	v: ['м'],
	b: ['и'],
	n: ['т'],
	m: ['ь'],
	',': ['б'],
	'.': ['ю'],
	Z: ['Я'],
	X: ['Ч'],
	C: ['С'],
	V: ['М'],
	B: ['И'],
	N: ['Т'],
	M: ['Ь'],
	'<': ['Б'],
	'>': ['Ю'],
	я: ['z', 'я'],
	ч: ['x', 'ч'],
	с: ['c', 'с'],
	м: ['v', 'м'],
	и: ['b', 'и'],
	т: ['n', 'т'],
	ь: ['m', 'ь'],
	б: [',', 'б'],
	ю: ['.', 'ю'],
	ё: ['`', 'ё'],
	Я: ['Z', 'Я'],
	Ч: ['X', 'Ч'],
	С: ['C', 'С'],
	М: ['V', 'М'],
	И: ['B', 'И'],
	Т: ['N', 'Т'],
	Ь: ['M', 'Ь'],
	Б: [',', 'Б'],
	Ю: ['.', 'Ю']
};

// -----------------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------------

export default alternativeValues(keys);
